module.exports = __webpack_public_path__ + "static/img/15.7321dbb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/3/sp/15.png
// module id = 6Tw1
// module chunks = 0